import * as types from "../actions/ActionTypes";
// import _ from "lodash";

const defaultState = {
  adGetting: false,
  adGot: null,
  adGetError: "",
  adPosting: false,
  adPosted: null,
  adRewardPending: false,
  adReward: 0,
  adRewardError: {},
  adOpen: false,
  adPostError: "",
  showAdBlockerModal: false,
  hasAdBlock: false,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.AD_GET_PENDING:
      return Object.assign({}, state, {
        adGetting: true,
      });
    case types.AD_GET_FULFILLED:
      return Object.assign({}, state, {
        adGetting: false,
        adGot: action.payload,
      });
    case types.AD_GET_REJECTED:
      return Object.assign({}, state, {
        adGetting: false,
        adGetError: action.payload.response,
      });

    case types.AD_POST_PENDING:
      return Object.assign({}, state, {
        adPosting: true,
      });
    case types.AD_POST_FULFILLED:
      return Object.assign({}, state, {
        adPosting: false,
        adPosted: action.payload,
      });
    case types.AD_POST_REJECTED:
      return Object.assign({}, state, {
        adPosting: false,
        adPostError: action.payload.response,
      });

    case types.AD_REWARD_PENDING:
      return Object.assign({}, state, {
        adRewardPending: true,
      });
    case types.AD_REWARD_FULFILLED:
      return Object.assign({}, state, {
        adRewardPending: false,
        adReward: action.payload,
      });
    case types.AD_REWARD_REJECTED:
      return Object.assign({}, state, {
        adRewardPending: false,
        adRewardError: action.payload.response,
      });

    case types.AD_TOGGLE:
      return {
        ...state,
        adOpen: !state.adOpen,
      };

    case types.SHOW_AD_BLOCKER_MODAL: {
      return {
        ...state,
        showAdBlockerModal: !state.showAdBlockerModal,
      };
    }

    case types.HAS_AD_BLOCKER:
      return {
        ...state,
        hasAdBlock: true,
      };

    // case types.AD_RESET:
    //   return Object.assign({}, state, _.omit(defaultState, ["adReward"]));

    case "LOGOUT":
      return defaultState;
    default:
      return state;
  }
}
